/**
 * PULSE Cart Drawer
 * ------------------------------------------------------------
 * Benefit chips and upsell rows are rendered server-side by
 * Liquid into #CartDrawerTemplates and cloned in here — no
 * client-side JSON assembly to silently fail.
 *
 * Cart mutations use Shopify's real Cart AJAX API.
 * Checkout is a plain link to /checkout — Shopify owns it.
 */
(function(){
  var overlay = document.getElementById('CartOverlay');
  if(!overlay) return;

  var closeBtn = document.getElementById('CartDrawerClose');
  var body = document.getElementById('CartDrawerBody');
  var foot = document.getElementById('CartDrawerFoot');
  var subtotalEl = document.getElementById('CartSubtotal');

  var benefitsTpl = document.getElementById('CartBenefitsTemplate');
  var upsellsTpl = document.getElementById('CartUpsellsTemplate');

  var cfg = { freeShippingThreshold: 0, productUrl: '' };
  var cfgEl = document.getElementById('CartDrawerConfig');
  if(cfgEl){
    try{ cfg = JSON.parse(cfgEl.textContent) || cfg; }
    catch(e){ console.warn('PULSE: drawer config parse failed (non-critical)', e); }
  }

  function money(c){
    var v = c / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(ch){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
  }); }

  function openDrawer(){
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeDrawer(){
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) closeDrawer(); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')) closeDrawer();
  });

  function shippingHtml(total){
    var t = cfg.freeShippingThreshold;
    if(!t || t <= 0) return '';
    var threshold = t * 100;
    var remaining = threshold - total;
    if(remaining <= 0){
      return '<div class="cart-shipping-progress"><div class="cart-shipping-progress-label"><strong>You have unlocked free shipping</strong></div><div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:100%"></div></div></div>';
    }
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    return '<div class="cart-shipping-progress"><div class="cart-shipping-progress-label">Add <strong>' + money(remaining) + '</strong> more for free shipping</div><div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:' + pct + '%"></div></div></div>';
  }

  function lineHtml(item){
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') + '" alt="' + esc(item.product_title) + '" loading="lazy">'
      : '';
    var vt = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

    /* Chosen bundle mix, stored as line item properties */
    var props = '';
    if(item.properties){
      var chips = Object.keys(item.properties).filter(function(k){
        return k.charAt(0) !== '_' && item.properties[k];
      }).map(function(k){
        return '<span class="cart-line-prop">' + esc(item.properties[k]) + ' × ' + esc(k) + '</span>';
      });
      if(chips.length) props = '<div class="cart-line-props">' + chips.join('') + '</div>';
    }

    return '<div class="cart-line" data-key="' + item.key + '">' +
      '<div class="cart-line-image">' + img + '</div>' +
      '<div class="cart-line-info">' +
        '<h4>' + esc(item.product_title) + '</h4>' +
        (vt ? '<div class="cart-line-variant">' + esc(vt) + '</div>' : '') +
        props +
        '<div class="cart-line-price">' + money(item.final_line_price) + '</div>' +
        '<button type="button" class="cart-line-remove" data-key="' + item.key + '">Remove</button>' +
      '</div>' +
      '<div class="cart-line-qty"><div class="qty-stepper">' +
        '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span class="qty-value">' + item.quantity + '</span>' +
        '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
      '</div></div>' +
    '</div>';
  }

  /* Clone Liquid-rendered upsells; hide anything already in the cart.
     Mix-picker bundles stay visible even when in the cart, since a
     second bundle may use a different mix. */
  function buildUpsells(cart){
    if(!upsellsTpl) return null;
    var wrap = upsellsTpl.firstElementChild;
    if(!wrap) return null;

    var clone = wrap.cloneNode(true);
    var list = clone.querySelector('.cart-upsell-list');
    if(!list) return null;

    var inCart = (cart.items || []).map(function(i){ return String(i.variant_id); });
    var rows = Array.prototype.slice.call(list.querySelectorAll('.cart-upsell'));
    var visible = [];

    rows.forEach(function(row){
      var isMix = !!row.querySelector('[data-bundle-size]');
      if(!isMix && inCart.indexOf(row.getAttribute('data-variant')) !== -1){
        row.parentNode.removeChild(row);
      } else {
        visible.push(row);
      }
    });

    if(!visible.length) return null;

    /* Cheapest first.

       This previously sorted by biggest saving, which structurally
       guaranteed the most expensive bundle took the top slot — a
       $900 team pack shown to someone who has just committed to a
       ~$300 order, at the exact moment price sensitivity peaks.

       Sorting by price puts the low-friction add-ons ($5 shipping
       protection, $18 priority processing) first, where they read
       as a reflex tick rather than a second purchase decision, and
       lets the bundles escalate below them. */
    visible.sort(function(a, b){
      function price(el){
        var p = el.querySelector('.cart-upsell-now');
        if(!p) return Infinity;
        var n = parseFloat(p.textContent.replace(/[^0-9.]/g, ''));
        return isNaN(n) ? Infinity : n;
      }
      return price(a) - price(b);
    });
    visible.forEach(function(row){ list.appendChild(row); });

    return clone;
  }

  function emptyHtml(){
    var cta = cfg.productUrl
      ? '<a href="' + cfg.productUrl + '" class="btn btn-primary" data-nav-link>Shop PULSE Boots</a>'
      : '';
    return '<div class="cart-empty">' +
      '<div class="portal-icon"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><path d="M7 3v6l-2 2v7a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-4l-3-3V3"/></svg></div>' +
      '<h3>Your bag is empty</h3><p>Add PULSE to get started.</p>' + cta +
    '</div>';
  }

  function render(cart){
    if(!body || !foot) return;
    body.innerHTML = '';

    if(!cart.items || !cart.items.length){
      body.insertAdjacentHTML('beforeend', emptyHtml());
      var emptyUps = buildUpsells(cart);
      if(emptyUps) body.appendChild(emptyUps);
      foot.hidden = true;
      updateBadge(0);
      return;
    }

    body.insertAdjacentHTML('beforeend', shippingHtml(cart.total_price));

    if(benefitsTpl && benefitsTpl.firstElementChild){
      body.appendChild(benefitsTpl.firstElementChild.cloneNode(true));
    }

    body.insertAdjacentHTML('beforeend',
      '<div class="cart-line-list">' + cart.items.map(lineHtml).join('') + '</div>');

    var ups = buildUpsells(cart);
    if(ups) body.appendChild(ups);

    foot.hidden = false;
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
    updateBadge(cart.item_count);
  }

  function updateBadge(n){
    document.querySelectorAll('.cart-count-badge').forEach(function(el){
      el.textContent = n;
      el.classList.toggle('is-visible', n > 0);
    });
  }

  function refreshCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(e){ console.warn('PULSE: cart fetch failed', e); });
  }

  function changeLine(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(e){ console.warn('PULSE: cart change failed', e); });
  }

  if(body){
    body.addEventListener('click', function(e){
      var q = e.target.closest('.qty-btn');
      if(q){ changeLine(q.dataset.key, Math.max(0, parseInt(q.dataset.qty, 10))); return; }

      var rm = e.target.closest('.cart-line-remove');
      if(rm){ changeLine(rm.dataset.key, 0); return; }

      var up = e.target.closest('.cart-upsell-add');
      if(up && !up.hasAttribute('data-bundle-size') && window.PulseCart){
        var label = up.querySelector('.cart-upsell-add-label');
        up.disabled = true;
        if(label) label.textContent = '…';
        window.PulseCart.add(up.getAttribute('data-variant-id'), 1)
          .then(function(){ return refreshCart(); })
          .catch(function(err){
            console.error('PULSE: drawer upsell add failed', err);
            if(label) label.textContent = 'Error';
            up.disabled = false;
          });
      }
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cart-open]');
    if(t){ e.preventDefault(); openDrawer(); }
  });

  refreshCart();
  window.addEventListener('pulse:navigated', refreshCart);
  window.addEventListener('pulse:cart-updated', refreshCart);
})();
